import {ClusterWorkflowTemplateContainer} from './cluster-workflow-template-container';

export default {
    component: ClusterWorkflowTemplateContainer
};
